import React, { useState } from 'react';

import CancellationPolicies from 'components/CancellationPolicies';
import HotelBookingInfo from 'components/HotelBookingInfo';
import HotelStars from 'components/HotelsStars';
import Map from 'components/Map';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelDetailsHotel, Requester, Price } from 'models/travelDetails';

import GuestCard from './components/GuestCard';
import RoomDetails from './components/RoomDetails';
import { Container, Title, HotelImage, HotelName, HotelAddress, Section } from './styles';

interface Props {
  hotel: TravelDetailsHotel;
  requester: Requester;
  price: Price;
}

const Hotel = ({ hotel, requester, price }: Props) => {
  const { t } = useStoreTranslation();
  const [show, setShow] = useState(false);

  return (
    <Container>
      <Section>
        <Title>{t('travelDetails.hotels.title')}</Title>
        {hotel.image && <HotelImage src={hotel.image} alt="hotel-image" />}
        <HotelName>{hotel.name}</HotelName>
        <HotelStars count={hotel.category} value={hotel.category} />
        <HotelAddress>{hotel.address}</HotelAddress>
        <HotelBookingInfo checkIn={hotel.checkIn} checkOut={hotel.checkOut} />
        <RoomDetails hotel={hotel} price={price} />
      </Section>
      <Map lat={hotel.latitude} lng={hotel.longitude} address={hotel.address} />
      <Section>
        <CancellationPolicies data={hotel.cancellationPolicies} show={show} onClick={() => setShow(!show)} />
        <GuestCard requester={requester} confirmationCode={hotel.confirmation} />
      </Section>
    </Container>
  );
};

export default Hotel;
